import BaseStore from './BaseStore';
import { Map } from 'immutable';
import { ActionTypes, JourneyDirections } from '../constants/AppConstants';

import localStorageHelper from '../helpers/LocalStorage';
import AmendRequest from '../records/amend/Request';
import AmendConfig from '../records/amend/Config';
import Trip from '../records/Trip';

const STORAGE_KEY = 'amendConfig';
const CONFIG_TTL = 60 * 60;

export class AmendStore extends BaseStore {

    getInitialState () {
        const config = localStorageHelper
              .objectFromLocalStorage(STORAGE_KEY, AmendConfig);

        return new Map({
            config: config,
            request: new AmendRequest(),
            currentTrip: null,
            tookPayment: true
        });
    }

    handleAuthFinished ({ order }) {
        const request = this.get('request');
        this.setState(
            this.state.set('request', request.setOrder(order))
        );
    }

    handleConfig ({ config }) {
        localStorageHelper.objectToLocalStorage(STORAGE_KEY, config, CONFIG_TTL);
        this.setState(this.state.set('config', config));
    }

    handleUpdated ({ amendRequest }) {
        this.setState(this.state.set('request', amendRequest));
    }

    handleSearchStarted ({ search }) {
        this.setState(
            this.state.set('currentTrip', new Trip({ search }))
        );
    }

    handleSearchUpdated ({ search }) {
        const trip = this.state.get('currentTrip');
        this.setState(
            this.state.set('currentTrip', trip.set('search', search))
        );
    }

    handleResultsUpdated ({ result, tripDirection }) {
        const trip = this.state.get('currentTrip');
        const nextTrip = trip
              .set('hasServiceProvider', result.hasServiceProvider)
              .resetSelected(tripDirection);

        this.setState(
            this.state.set('currentTrip', nextTrip)
        );
    }

    handleSearchFinished ({ hasServiceProvider }) {
        const trip = this.state.get('currentTrip');
        const nextTrip = trip
              .set('hasServiceProvider', hasServiceProvider);

        this.setState(
            this.state.set('currentTrip', nextTrip)
        );
    }

    handleInwardServiceSelected ({ service }) {
        const trip = this.state.get('currentTrip');
        const nextTrip = trip
              .set('returnJourney', service)
              .set('raw', false)
                .setIn(['fares', 'returnSingle'], null);

        this.setState(
            this.state.set('currentTrip', nextTrip)
        );
    }

    handleOutwardServiceSelected ({ service }) {
        const trip = this.state.get('currentTrip');
        const nextTrip = trip
              .set('outwardJourney', service)
              .set('raw', false)
              .resetFares();

        this.setState(
            this.state.set('currentTrip', nextTrip)
        );
    }

    handleServiceSelected ({ service, direction }) {
        if (direction === JourneyDirections.OUTWARD) {
            this.handleOutwardServiceSelected({ service });
        }

        if (direction === JourneyDirections.INWARD) {
            this.handleInwardServiceSelected({ service });
        }
    }

    handleSelectFare ({ fare, direction, service, fareCategory, fareClass }) {
        const trip = this.state.get('currentTrip');
        const nextTrip = trip
              .set('fareCategory', fareCategory)
              .set('fareClass', fareClass)
              .setFareForDirection(direction, fare)
              .setServiceForDirection(direction, service)
              .setSeatingForDirection(direction, fare, service)
              .set('raw', false);

        this.setState(
            this.state.set('currentTrip', nextTrip)
        );
    }

    handleTripFinished ({ amendRequest }) {
        this.handleUpdated({ amendRequest });
    }

    handlePlusBusSet({ trip }) {
        this.setState(
            this.state.set('currentTrip', trip)
        );
    }

    handleTookPayment({ tookPayment }) {
        this.setState(
            this.state.set('tookPayment', tookPayment)
        );
    }

    cancel() {
        this.resetState();
    }

    getActionHandlers () {
        return {
            [ActionTypes.AMEND_CONFIG_LOADED]: this.handleConfig,
            [ActionTypes.AMEND_UPDATED]: this.handleUpdated,
            [ActionTypes.AMEND_CANCELLED]: this.cancel,
            [ActionTypes.AMEND_RESET]: this.resetState,
            [ActionTypes.AMEND_PAYMENT_AUTH_FINISHED]: this.handleAuthFinished,
            [ActionTypes.AMEND_SHOW_EARLIER_TRAINS_STARTED]: this.handleSearchUpdated,
            [ActionTypes.AMEND_SHOW_LATER_TRAINS_STARTED]: this.handleSearchUpdated,
            [ActionTypes.AMEND_SHOW_EARLIER_TRAINS_FINISHED]: this.handleResultsUpdated,
            [ActionTypes.AMEND_SHOW_LATER_TRAINS_FINISHED]: this.handleResultsUpdated,
            [ActionTypes.AMEND_SEARCH_FAILED]: this.handleSearchStarted,
            [ActionTypes.AMEND_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.AMEND_SEARCH_LOADED]: this.handleSearchUpdated,
            [ActionTypes.AMEND_SEARCH_UPDATED]: this.handleSearchUpdated,
            [ActionTypes.AMEND_SEARCH_FINISHED]: this.handleSearchFinished,
            [ActionTypes.AMEND_SERVICE_SELECTED]: this.handleServiceSelected,
            [ActionTypes.AMEND_FARE_SELECTED]: this.handleSelectFare,
            [ActionTypes.AMEND_TRIP_STARTED]: this.handleTripStarted,
            [ActionTypes.AMEND_TRIP_FAILED]: this.handleTripFailed,
            [ActionTypes.AMEND_TRIP_FINISHED]: this.handleTripFinished,
            [ActionTypes.AMEND_SET_FINISHED]: this.handleSetFinished,
            [ActionTypes.AMEND_PLUSBUS_SET]: this.handlePlusBusSet,
            [ActionTypes.AMEND_TOOK_PAYMENT]: this.handleTookPayment
        };
    }
}

const instance = new AmendStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/AmendStore.js